import { useEffect, useState } from "react";
import { ArrowLeftOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Space, Flex, Typography, Table, message } from "antd";
import TableComponent from "../../../space/components/table/Index";
import { useTranslation } from "react-i18next";
import { createRole } from "../../../../services/adminServices";
import { showLoader } from "../../../../utils/showloader";
import { trimStringValues } from "../../../../utils/trimStrings";
import { useDispatch, useSelector } from "react-redux";
import { setFormType } from "../../../../redux/slices/roleUserSlice";


const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 6 }, // Adjust the span for width
};

const AddEditRole = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { setSubmitRole, submitRole, permissions, setShowForm, reloadTable, selectedRole } = props

    const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const [filteredEntitlements, setFilteredEntitlements] = useState([])
    const [selectedEntitlements, setSelectedEntitlements] = useState([])
    const [showPermissionModal, setShowPermissionModal] = useState(false)
    const [selectedPermissionTableData, setSelectedPermissionTableData] = useState([])

    const { userInfo } = useSelector(state => state.user);

    useEffect(() => {
        setFilteredEntitlements(permissions)
    }, [])

    useEffect(() => {
        if (selectedRole) {
            form.setFieldsValue({ role: selectedRole.role, description: selectedRole.description })
            setSelectedEntitlements(selectedRole.entitlements)
            setSelectedRowKeys(selectedRole.entitlements);
            let updatedPermissions = permissions.filter(permission => selectedRole.entitlements.includes(permission.name));
            setSelectedPermissionTableData(updatedPermissions)
            let currentEntitlesments = selectedRole.entitlements.map(entitlement => entitlement)
            setDefaultSelectedKeys(currentEntitlesments)

        } else {
            form.resetFields();
            setSelectedEntitlements([])
        }
    }, [selectedRole, permissions])



    // useEffect(() => {
    //     form.resetFields();
    //     setSelectedEntitlements([])
    // },[])

    useEffect(() => {
        if (submitRole) {
            form.submit()
        }
    }, [submitRole])

    const tableConfig = {
        type: "table",
        id: "entitlements_table",
        selectable: true,
        rowKey: 'name',
        columns: [
            {
                title: t('Permission'),
                custom_search: true,
                dataIndex: 'name',
            },
            {
                title: t('Description'),
                dataIndex: 'description',
                no_filter: true
            },
        ]
    }

    const handlePermissionModalClose = () => {
        setShowPermissionModal(false)
    }

    const handleEntitlementsSelection = () => {
        handlePermissionModalClose()
        let currentEntitlements = localStorage.getItem("selectedRows") ? JSON.parse(localStorage.getItem("selectedRows")) : []
        if (currentEntitlements.length > 0) {
            currentEntitlements = currentEntitlements.map(entitle => entitle.name)
        }
        setSelectedEntitlements(currentEntitlements)
        // setDefaultSelectedKeys()
        let updatedPermissions = permissions.filter(permission => currentEntitlements.includes(permission.name));
        setSelectedPermissionTableData(updatedPermissions)

        // localStorage.removeItem("selectedRows")
    }

    const getSelectedData = (selectedData) => {
        localStorage.setItem("selectedRows", JSON.stringify(selectedData))
    }

    const deleteSelectedPermission = (record) => {
        let updatedPermissions = selectedPermissionTableData.filter(permission => permission.name !== record.name);
        setSelectedPermissionTableData(updatedPermissions)
        let updatedSelected = selectedEntitlements.filter(permission => permission !== record.name)
        setSelectedEntitlements(updatedSelected)
        setSelectedRowKeys(updatedSelected)
    }

    const permissionTableColumns = [
        {
            title: t('Permission'),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            key: 'name'
        },
        {
            title: t('Action'),
            dataIndex: '',
            width: "10%",
            render: (text, record) => {
                return <Button
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={() => deleteSelectedPermission(record)}
                />
            }
        }
    ]

    const onSaveRole = async (values) => {
        let postData = { ...values, entitlements: selectedEntitlements }
        if(selectedRole) {
            postData.roleId = selectedRole.roleId
        }
        // if(selectedRole){

        // }
        // return
        showLoader(true)
        let userResp = await createRole(postData, userInfo)
        showLoader(false)
        if (userResp.status === 200) {
            message.success(userResp.message);
            dispatch(setFormType(""))
            setShowForm(false)
            reloadTable();
        } else {
            message.error(userResp.message)
        }
        setSubmitRole(false)
    }

    const onSubmitRole = async (values) => {
        try {
            await form.validateFields();
            onSaveRole(trimStringValues(values))
        } catch (errorInfo) {
        }
        setSubmitRole(false)
    }
    const goBack = () => {
        dispatch(setFormType(""))
        setShowForm(false)

    }

    

    const rowSelection = {
        selectedRowKeys,   // ✅ NOT defaultSelectedKeys
        onChange: (keys, rows) => {
            setSelectedRowKeys(keys);
            localStorage.setItem("selectedRows", JSON.stringify(rows));
        },
    }

    return (
        <>
            <Typography.Title level={4} className="p-0 m-0" >
                <span><ArrowLeftOutlined className="cursor-pointer" style={{ marginRight: "12px" }} onClick={goBack} />{selectedRole ? t("Update Role") : t("Add Role")}</span>

            </Typography.Title>
            <>
                <Form form={form} onFinish={onSubmitRole} layout="vertical" {...formItemLayout}>
                    <Form.Item label={t("Role Title")} name="role" rules={[{ required: true, whitespace: true, message: t("Role title is required") }]}>
                        <Input placeholder={t("Enter role title")} />
                    </Form.Item>
                    <Form.Item label={t("Description")} name="description">
                        <Input placeholder={t("Enter description")} />
                    </Form.Item>
                </Form>
                {
                    selectedEntitlements.length === 0 &&
                    <Button className="bordered-button" icon={<PlusOutlined />} onClick={() => setShowPermissionModal(true)}>{t("Add Permission")}</Button>
                }
            </>

            {
                selectedEntitlements.length > 0 ?
                    <>
                        <Flex justify="space-between" align="center" style={{ margin: "24px 0 20px 0" }}>
                            <Typography.Title level={4} style={{ padding: 0, margin: "0" }} >{t("Permissions Granted")}</Typography.Title>
                            <Button className="bordered-button" icon={<PlusOutlined />} onClick={() => setShowPermissionModal(true)}>{t("Add Permission")}</Button>
                        </Flex>
                        <div className="tab-content">
                            <Table columns={permissionTableColumns} dataSource={selectedPermissionTableData} pagination={{ "position": ["bottomLeft"] }} />
                        </div>
                    </>
                    : null
            }

            <Modal title={t("Select Permissions")} className="entitlements-selector-modal" footer={false} open={showPermissionModal} onOk={handlePermissionModalClose} onCancel={handlePermissionModalClose}>
                <div>
                    <Space direction="vertical" className="columns-selector-container">
                        <Table rowKey="name" columns={tableConfig.columns} dataSource={filteredEntitlements} rowSelection={rowSelection} />

                    </Space>
                    <Flex justify="flex-start" gap={8} align="center" style={{ padding: "8px 24px 24px" }}>
                        <Button className="submit-button" onClick={handleEntitlementsSelection}>{t("Add")}</Button>
                        <Button default style={{ border: "none" }} onClick={() => setShowPermissionModal(false)}>{t("Cancel")}</Button>
                    </Flex>
                </div>
            </Modal>
        </>
    )
}

export default AddEditRole